import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const block: ContentBlock<"checklist"> = {
  id: makeId("checklist-at-lab"),
  kind: "checklist",
  tags: ["pre-cycle", "lab", "testing"],
  title: "AT ANY LAB",
  icon: "🔬",
  body: {
    items: [
      {
        id: "day3",
        label: "Day 3 hormone panel",
        detail:
          "Must be done on cycle day 2-4. These baseline hormones tell your RE how your ovaries are likely to respond.",
        tags: [
          { label: "Her test", colorKey: "coral" },
          { label: "Blood draw", colorKey: "blue" },
          { label: "Day 2-4", colorKey: "textLight" },
        ],
      },
      {
        id: "thyroid",
        label: "Thyroid panel (TSH, T3, T4)",
        detail:
          "Thyroid issues are common and directly affect fertility. Ideally TSH should be under 2.5 for conception.",
        tags: [
          { label: "Her test", colorKey: "coral" },
          { label: "Blood draw", colorKey: "blue" },
        ],
      },
      {
        id: "vitd",
        label: "Vitamin D level",
        detail:
          "Low vitamin D is linked to lower IVF success rates. Supplementing is cheap and safe.",
        tags: [
          { label: "Both partners", colorKey: "blue" },
          { label: "Blood draw", colorKey: "blue" },
        ],
      },
    ],
  },
};

registerBlock(block);
